import React from 'react';
import { Link } from 'react-router-dom';


export default function Services() {
  const serviceData = [
    { title: 'Architecture', desc: 'Modern websites & business solutions.', img: '/images/home/homeservice1.png', text:'Crafting intelligent and timeless commercial spaces with precision-driven architectural solutions from Bengaluru.' },
    { title: 'Interior', desc: 'Custom apps for iOS & Android.', img: '/images/home/homeservice2.png', text:'Creating refined, high-performance interiors with bespoke design and flawless turnkey execution' },
    { title: 'Turnkey solution', desc: 'Grow your brand online with strategy.', img: '/images/home/homeservice3.png', text:'Integrated turnkey solutions covering design, execution, procurement, and project management from start to finish.' }
  ];

  return (
    <section className="py-10 bg-gray-100">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-4">Our Services</h2>
        <div className="grid md:grid-cols-3 gap-8">
          {serviceData.map((service, idx) => (
            <div
              key={idx}
              className="relative h-96 rounded-xl overflow-hidden shadow-lg transform transition duration-500 hover:scale-105 group"
            >
              <img
                src={service.img}
                alt={service.title}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />

              <div className="absolute inset-0 bg-black bg-opacity-40"></div>

              <div className="absolute inset-0 flex flex-col items-center justify-center text-center z-10 text-white">

                <h3 className="text-2xl font-bold mb-2">{service.title}</h3>
                <p
                  className="text-sm px-2 md:px-8 mb-2 
                    max-h-0 opacity-0 overflow-hidden 
                    transition-all duration-700 
                    group-hover:max-h-40 group-hover:opacity-100 
                    group-hover:translate-y-0 translate-y-4"
                >
                  {service.text}
                </p>
                <Link
                  className="font-bold text-lg flex items-center justify-center px-2 py-1 rounded-md 
                  bg-white/20 backdrop-blur-sm transition-all duration-700 
                    group-hover:translate-y-0 hover:bg-white/30 hover:text-red-600"
                  to="/services"
                >
                  View Details
                </Link>

              </div>

              <div className="absolute inset-0 pointer-events-none bg-gradient-to-tl from-white/0 via-white/10 to-white/0 opacity-0 group-hover:opacity-30 transition-opacity duration-500"></div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}